import _ from 'lodash'

const Hide = ({ ifEmpty, data, ...props }) => {
    const isEmpty = _.isEmpty(ifEmpty) && _.isEmpty(data)
    return isEmpty ? null : props.children
}

export { Hide }
